
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M14.5 7.227c0 4.455-6 8.273-6 8.273s-6-3.818-6-8.273c0-1.519.632-2.975 1.757-4.05A6.15 6.15 0 0 1 8.5 1.5c1.591 0 3.117.603 4.243 1.677a5.6 5.6 0 0 1 1.757 4.05"}}),_c('path',{attrs:{"d":"M8.5 8.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4"}})])])
          )
        }
      }
    